import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';

export const integrationRedirections: RedirectionStateObject = {
  'dashboard.integrations': () => `/360/integrations/shippers`,
  'dashboard.integrations.collectors': params => `/360/integrations/shippers${tanstackUrlSearch(params)}`,
  'dashboard.integrations.collectors-new': () => `/360/integrations/shippers/new`,
  'dashboard.integration': ({ content, ...params }) =>
    `/360/integrations/${uriSafe(content)}${tanstackUrlSearch(params)}`,
  'dashboard.customIntegration': () => null,
  'dashboard.integrations.fleet': params => `/360/integrations/collectors${tanstackUrlSearch(params)}`,
  'dashboard.integrations.new': params => `/360/integrations/collectors/new${tanstackUrlSearch(params)}`,
  'dashboard.integrations.edit': ({ id, ...params }) =>
    `/360/integrations/collectors/config/${uriSafe(id)}${tanstackUrlSearch(params)}`,
  'dashboard.integrations.installation': ({ id, ...params }) =>
    `/360/integrations/collectors/installation/${uriSafe(id)}${tanstackUrlSearch(params)}`,
};
